import api from 'api';

export const loadResults = api('POST /api/players-activities/last-activity');

export const updateActivity = api(
  'POST /api/players-activities/last-activity/update'
);
